import { Injectable, inject } from "@angular/core";
import { BitsApis } from "@app/core/APIs/bits-apis";
import { silentCrudApiOptions, unwrapResponse } from "@app/core/helpers/crud-response.helpers";
import { CrudApiService } from "@ez-library/services/crud-api.service";
import { Observable, map } from "rxjs";
import {
    PhmsIntakeInterfaceIngestRequest,
    PhmsIntakeReconciliationRunDto,
} from "./phms-intake-reconciliation.models";

@Injectable({ providedIn: "root" })
export class PhmsIntakeReconciliationService {
    private readonly bitsApis = inject(BitsApis);
    private readonly crudService = inject(CrudApiService);

    ingest(
        sourceKey: string,
        request: PhmsIntakeInterfaceIngestRequest,
    ): Observable<PhmsIntakeReconciliationRunDto> {
        return this.crudService
            .postByUrl<PhmsIntakeReconciliationRunDto>(
                this.bitsApis.core.manual.postPhmsIntakeInterfaceIngest(sourceKey),
                buildIngestPayload(request),
                silentCrudApiOptions,
            )
            .pipe(map((response) => unwrapResponse(response)));
    }

    getRun(sourceKey: string, runId: number): Observable<PhmsIntakeReconciliationRunDto> {
        return this.crudService
            .getbyUrl<PhmsIntakeReconciliationRunDto>(
                this.bitsApis.core.manual.getPhmsIntakeReconciliationRun(sourceKey, runId),
                silentCrudApiOptions,
            )
            .pipe(map((response) => unwrapResponse(response)));
    }
}

function buildIngestPayload(
    request: PhmsIntakeInterfaceIngestRequest,
): PhmsIntakeInterfaceIngestRequest {
    const payload: PhmsIntakeInterfaceIngestRequest = {
        records: request.records.map((record) => {
            const mapped = {
                incarceratedPersonDisplayName: record.incarceratedPersonDisplayName.trim(),
                incarceratedPersonIdentifier: record.incarceratedPersonIdentifier.trim(),
                programScopeKey: record.programScopeKey.trim(),
            } as PhmsIntakeInterfaceIngestRecordRequestPayload;

            const sourceRecordKey = record.sourceRecordKey?.trim();
            if (sourceRecordKey) {
                mapped.sourceRecordKey = sourceRecordKey;
            }

            return mapped;
        }),
    };

    const sourceSystemKey = request.sourceSystemKey?.trim();
    if (sourceSystemKey) {
        payload.sourceSystemKey = sourceSystemKey;
    }

    return payload;
}

interface PhmsIntakeInterfaceIngestRecordRequestPayload {
    incarceratedPersonDisplayName: string;
    incarceratedPersonIdentifier: string;
    programScopeKey: string;
    sourceRecordKey?: string;
}
